import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import {API_URL} from "@/common/config";
import { VERSION } from '@/common/version'
import router from '@/router'
import store from '@/store/index'

const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        Vue.axios.defaults.headers.common['X-Client-Version'] = VERSION;
        Vue.axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';
        Vue.axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

        Vue.axios.interceptors.response.use(
            response => response,
            error => {
                if (
                    store.getters.isAuthenticated &&
                    error.response &&
                    error.response.status &&
                    error.response.status === 401 &&
                    error.response.data &&
                    error.response.data.message &&
                    error.response.data.message === 'Unauthenticated.'
                ) {
                    store.dispatch('logout')
                        .then(() => router.push({name: "login"}))
                } else {
                    return Promise.reject(error);
                }
            }
        )
    },

    setHeader(token) {
        if(!token) {
            Vue.axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${JwtService.getToken()}`;
        } else {
            Vue.axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${token}`;
        }
    },

    setOrganizationHeader() {
        Vue.axios.defaults.headers.common[
            "Authorization"
            ] = `Bearer ${JwtService.getOrganizationToken()}`;
    },

    get(resource, slug = "") {
        if (JwtService.getToken() !== null) {
            this.setHeader();
        } else if (JwtService.getOrganizationToken() !== null) {
            this.setOrganizationHeader();
        } else {
        }
        let params = '';
        if (!_.isNaN(slug)) {
            params = `${
                store.getters.organizationId || slug ? '?' : ''
            }${
                store.getters.organizationId ?
                'organization_id=' + store.getters.organizationId :
                ''
            }${
                store.getters.organizationId && slug ? '&' : ''
            }${
                slug
            }`
        }
        if (_.isObject(slug)) {
            let slugString = _.keys(slug).filter(key => (slug[key] != null && slug[key] !== 'null'))
                .map(key => key + '=' + slug[key]).join('&');
            let organizationString = `${
                store.getters.organizationId && !slug.hasOwnProperty('organization_id') ?
                'organization_id=' + store.getters.organizationId :
                ''
            }`

            params = `${
                organizationString || slugString ? '?' : ''
            }${ [ organizationString, slugString ].join(organizationString && slugString ? '&' : '')}`
        }
        return Vue.axios.get(`${resource}${params}`)
    },

    getNewLogin(resource, slug = "") {
        let params = '';
        if (!_.isNaN(slug)) {
            params = `${slug ? '?' : ''}${slug}`
        }
        if (_.isObject(slug)) {
            let slugString = _.keys(slug).filter(key => (slug[key] != null && slug[key] !== 'null'))
            .map(key => key + '=' + slug[key]).join('&');

            params = `${slugString ? '?' : ''}${slugString}`
        }
        return Vue.axios.get(`${resource}${params}`);
    },

    post(resource, params = {}) {
        if (store.getters.organizationId && _.isObject(params)) {
            params.organization_id = store.getters.organizationId
        }
        return Vue.axios.post(`${resource}`, params);
    },

    update(resource, slug, params = {}) {
        if (store.getters.organizationId && _.isObject(params)) {
            params.organization_id = store.getters.organizationId
        }
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params = {}) {
        if (store.getters.organizationId && _.isObject(params)) {
            params.organization_id = store.getters.organizationId
        }
        return Vue.axios.put(`${resource}`, params);
    },

    delete(resource, params = {}) {
        if (store.getters.organizationId && _.isObject(params)) {
            params.organization_id = store.getters.organizationId
        }
        return Vue.axios.delete(`${resource}`, { data: params }).catch(error => {
            throw new Error(`[RWV] ApiService ${error}`);
        });
    }
};

export default ApiService;
